import { IconButton, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Input } from "../Input";
import { useSearch } from "../../hooks/useSearch";
import CircularProgress from "../CircularProgress";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { selectExtension } from "../../features/extension/extension.selector";

type THeaderProductSearchProps = {
  onSearchEnd?: () => void;
};

export const HeaderProductSearch = ({
  onSearchEnd,
}: THeaderProductSearchProps) => {
  const navigate = useNavigate();
  const { isExtension } = useAppSelector(selectExtension);
  
  // Use extension route if in extension context, otherwise use main app route
  const getSearchRoute = (q: string) => {
    return isExtension ? `/product-analyzer/search?q=${q}` : `/search?q=${q}`;
  };

  const { searchValue, setSearchValue, handleSearch, isLoading } = useSearch({
    onSuccess: ({ status, q }) => {
      if (status === "multiple_products") {
        navigate(getSearchRoute(q));
      } else if (status === "no_products") {
        navigate(`/product-analyzer?q=${q}&noProducts=true`);
      } else {
        navigate(`/product-analyzer?asin=${q}`);
      }
      setSearchValue("");
      onSearchEnd?.();
    },
    onError: ({ q }) => {
      navigate(getSearchRoute(q));
      setSearchValue("");
      onSearchEnd?.();
    },
  });

  return (
    <Input
      fullWidth
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          handleSearch(searchValue);
        }
      }}
      value={searchValue}
      disabled={isLoading}
      onChange={(e) => setSearchValue(e.target.value)}
      size="small"
      type="search"
      placeholder="Search ASIN, UPC, ISBN, or keywords"
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment
              position="start"
              onClick={() => handleSearch(searchValue)}
            >
              <IconButton>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
          endAdornment: isLoading && (
            <InputAdornment position="end" sx={{ ml: 1 }}>
              <CircularProgress />
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default HeaderProductSearch;
